export enum FilterSidebarEventEnum {
    UNKNOWN = 0,
    CLOSE,
    APPLY,
    SAVE,
    RELOAD_FILTER,
    ADD,
    REMOVE,
    SHARE,
}
